import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import {
  getAllUsers,
  getArts,
} from "../../lib/actions";
import "./creator.css";
import Button from "../Button";
import { LoaderIcon } from "../svg/Icons";
import { Query } from "appwrite";

const Section = styled.section`
  min-height: 100vh;
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 80%;
  min-height: 80vh;
  margin: 0 auto;
  //   display: flex;
  //   justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
    min-height: 100vh;
  }
`;

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  //   width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    // text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    font-size: 24px;
  }
  .text-tiny {
    font-size: 18px;
  }
  .text-3 {
    color: red;
  }
  .text-4 {
    color: red !important;
    font-size: 16px !important;
  }
  .small {
    font-size: 36px;
  }
  .smaller {
    font-size: 24px;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: flex-start;
  }
  @media (max-width: 40em) {
    // width: 90%;
  }
`;

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontmd};
    font-weight: 600;
    margin-bottom: 5px;
  }
  p span {
    color: orange;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const CreatorComp = () => {
  const { username } = useParams();
  const [data, setData] = useState(null);
  const [arts, setArts] = useState([]);
  const [isCurrentUser, setIsCurrentUser] = useState(false);

  useEffect(() => {
    const fetchuser = async () => {
      try {
        const userData = await getAllUsers([
            Query.equal("username", username),
          ]);
        setData(userData[0]);
        
        const raw = localStorage.getItem("userId");

        if (raw) {
          const id = JSON.parse(raw);
          console.log(username);
          if (userData[0]?.$id === id) {
            setIsCurrentUser(true);
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchuser();
  }, [username]);

  useEffect(() => {
    const fetchArts = async () => {
      try {
        const userId = data?.$id;
        if (data?.$id) {
            console.log(userId);
            
          const userArts = await getArts(userId);
          setArts(userArts);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchArts();
  }, [data]);
  const mintedArts = arts.filter((arts) => arts.minted === true);
  const unMintedArts = arts.filter((arts) => arts.minted === false);
  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <Div>
          <Title>
            <span>Creator Details</span>
          </Title>
          <p>
            <Link to="/">Creators</Link>

            <span> / Creator Details</span>
          </p>
        </Div>

        <div className="headerWraper">
          <div className="col1"></div>
          <div className="col2">
            <section className="artistSection">
              <div className="artistHeight">
                <img
                  src={data?.avatar ?? "https://i.pravatar.cc/100"}
                  alt="Artist"
                />
              </div>
              {/* <div className="artistHeight description">
                
              </div> */}
              <Title style={{ textAlign: "center" }}>
                <h3 className="text-2">{data?.name ?? "John Doe"}</h3>
                <p
                  className="text-tiny"
                  style={{ color: "gray", marginTop: "10px" }}
                >
                  @{data?.username ?? "@johndoe"}
                </p>
              </Title>
              <div className="artistHeight"></div>
            </section>
            <section className="detailsSection">
              

              <div className="detailWrapper">
                <div className="HIDE">
                  <p>Created</p>
                  <h3>{arts.length ?? <LoaderIcon width={"20"} />}</h3>
                </div>
                <div>
                  <p>Minted</p>
                  <h3>{mintedArts.length ?? <LoaderIcon />}</h3>
                </div>
              </div>

              {/* <div>
                <a
                  href="https://x.com/trademillennia?s=21"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="twitter"
                >
                  <Twitter />
                </a>
              </div> */}
            </section>
          </div>
        </div>

        <div className="artWrapper">
          <Title>
            <span className="text-2">Minted Arts</span>
          </Title>
          <div className="artGrid">
            {mintedArts.map((art, index) => (
              <div className="artCard" key={index}>
                <img src={art.img} alt={art.name} />
                <div className="artDetails">
                  <h4>{art.name}</h4>
                  <p>{art.description}</p>
                  <p className="text-tiny">Price: {art.price} ETH</p>
                  <Link
                    to={`/nft/${art.$id}`}
                    state={{
                      img: art.img,
                      number: art.name,
                      price: art.price,
                      owner: art.userId.name,
                      ownerImg: art.userId.avatar,
                      description: art.description,
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <Button className="mintButton" text={"BUY"} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        { isCurrentUser && (
          <div className="artWrapper">
            <Title>
              <span className="text-2">Unminted Arts</span>
            </Title>
            <div className="artGrid">
              {unMintedArts.map((art, index) => (
                <div className="artCard" key={index}>
                  <img src={art.img} alt={art.name} />
                  <div className="artDetails">
                    <h4>{art.name}</h4>
                    <p>{art.description}</p>
                    <p className="text-tiny">Price: {art.price} ETH</p>
                    <Link to={`/mint`}>
                      <Button className="mintButton" text={"MINT"} />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Container>
      <Footer />
    </Section>
  );
};

export default CreatorComp;
